import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6a19b334"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "send-record-list" }
const _hoisted_2 = {
  key: 0,
  class: "send-record-empty"
}
const _hoisted_3 = {
  key: 0,
  class: "send-record-header"
}
const _hoisted_4 = { class: "col-user" }
const _hoisted_5 = { class: "col-app-file" }
const _hoisted_6 = { class: "col-status" }
const _hoisted_7 = { class: "col-time" }
const _hoisted_8 = { class: "col-user" }
const _hoisted_9 = { class: "line-sub" }
const _hoisted_10 = { class: "line-main" }
const _hoisted_11 = { class: "col-app-file" }
const _hoisted_12 = { class: "line-app" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "line-sub" }
const _hoisted_15 = ["title"]
const _hoisted_16 = { class: "col-status" }
const _hoisted_17 = {
  key: 2,
  class: "status-unknown"
}
const _hoisted_18 = { class: "col-time line-sub" }

import { getSvgIconDataUrl } from '@/utils/svg-icon-data-url'

import { useI18n } from 'vue-i18n'
import type { SensitiveWordsFileOutgoingLogRow } from '@/views/dashboard/data-safe/anti-external-control/service'
import { approvalLabelToValue } from '@/views/dashboard/data-safe/anti-external-control/types/approval-terminal-file-outsourcing'
import { formatTimeStamp } from '@/utils/time'
import { ControlResultState } from '@/views/dashboard/manage/outbound-control-log/index'


export default /*#__PURE__*/_defineComponent({
  __name: 'sensitive-outbound-events',
  props: {
    records: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

const { t } = useI18n()



function formatApplyTime(v: string | undefined) {
  if (v == null || v === '') return '--'
  return formatTimeStamp(v, 'YYYY-MM-DD HH:mm') || '--'
}

/** 与审批中心 UnifiedListApproval 中外发方式图标一致 */
function getSoftNameIcon(softName?: string): string {
  if (!softName) return ''
  const value = approvalLabelToValue[softName]
  if (!value) return ''
  try {
    return getSvgIconDataUrl(`views/dashboard/data-safe/anti-external-control/assets/approvalType/${value}`)
  } catch {
    return ''
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loading && !_ctx.records.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('common.noData')), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.records.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('overviewZone.sensitiveOutboundColTerminalUser')), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('overviewZone.sensitiveOutboundColChannelFile')), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('listColumns.status')), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('listColumns.time')), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (row, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: row.id || row.file_id || `${row.apply_time}-${index}`,
              class: "send-record-row"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(row.group_name || '--'), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(row.user_mark || '--'), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (getSoftNameIcon(row.soft_name))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "app-icon",
                        width: "18",
                        height: "18",
                        alt: "",
                        src: getSoftNameIcon(row.soft_name)
                      }, null, 8, _hoisted_13))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(row.soft_name || '--'), 1)
                ]),
                _createElementVNode("div", {
                  class: "line-main file-name",
                  title: row.file_name || ''
                }, _toDisplayString(row.file_name || '--'), 9, _hoisted_15)
              ]),
              _createElementVNode("div", _hoisted_16, [
                (row.control_result === _unref(ControlResultState).Blocked)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "danger",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('outboundControlLog.sendStatusBlocked')), 1)
                      ]),
                      _: 1
                    }))
                  : (row.control_result === _unref(ControlResultState).Released)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        type: "success",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('outboundControlLog.sendStatusReleased')), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_17, "—"))
              ]),
              _createElementVNode("div", _hoisted_18, _toDisplayString(formatApplyTime(row.apply_time)), 1)
            ]))
          }), 128))
        ], 64))
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}
}

})